jQuery( document ).ready(function($) { 
  

  new WOW().init();
  
  /* SlimMenu Prep */
  $('#navigation').slimmenu({
    resizeWidth: '980',
    collapserTitle: '',
    animSpeed: 0,
    easingEffect: null,
    indentChildren: false,
    childrenIndenter: '&nbsp;',
    expandIcon: '',
    collapseIcon: ''
  });

  /* Add scroll class toggle */
  $(function () {
    $(document).scroll(function () {
      var nav = $(".sticky-top");
      nav.toggleClass('scrolled', $(this).scrollTop() > nav.height());
    });
  });

  $('a[href*="#"]').on('click', function (e) {
    e.preventDefault();

    $('html, body').animate({
      scrollTop: $($(this).attr('href')).offset().top
    }, 250, 'linear');
  });

  //Function to have first Release note accordion open by default
  $(function(){
    $('.btn-link').eq(0).trigger('click');
});

}); 

$(window).scroll(function(){

  var wScroll = $(this).scrollTop();
  
  
  if($(window).scrollTop() > 1100){
  
  
      $(".home_parallax_bg").css({"transform" :  "translateY(0px)"});
     
  
  }
  else{
       $('.home_parallax_bg').css({
    'transform' : 'translate(0px, '+ wScroll /75 +'%)'
  });
       $(".home_parallax_bg").css("margin-top", "0px");
  }
  
  });